import { supabase } from '../../shared/supabase/supabaseClient';

export type EmployeeCommissionSummary = {
  employeeId: string;
  employeeName: string;
  taskCount: number;
  totalSales: number;
  totalCommission: number;
};

export type EmployeeCommissionDetail = {
  taskId: string;
  workOrderId: string;
  productName: string;
  quantity: number;
  unitPrice: number;
  lineTotal: number;
  commissionPercent: number | null;
  commissionAmount: number;
  workOrderStatus: string;
  createdAt: string;
};

export async function listEmployeeCommissions(params: {
  branchId: string;
  fromIso?: string | null;
  toIso?: string | null;
}): Promise<EmployeeCommissionSummary[]> {
  const { data, error } = await supabase.rpc('list_employee_commissions', {
    p_branch_id: params.branchId,
    p_from: params.fromIso ?? null,
    p_to: params.toIso ?? null,
  });
  if (error) throw new Error(error.message);
  const rows = (data ?? []) as Array<{
    employee_id: string;
    employee_name: string;
    task_count: number;
    total_sales: number;
    total_commission: number;
  }>;
  return rows.map((r) => ({
    employeeId: r.employee_id,
    employeeName: r.employee_name,
    taskCount: Number(r.task_count),
    totalSales: Number(r.total_sales),
    totalCommission: Number(r.total_commission),
  }));
}

export async function listEmployeeCommissionDetails(params: {
  employeeId: string;
  branchId: string;
  fromIso?: string | null;
  toIso?: string | null;
}): Promise<EmployeeCommissionDetail[]> {
  const { data, error } = await supabase.rpc('list_employee_commission_details', {
    p_employee_id: params.employeeId,
    p_branch_id: params.branchId,
    p_from: params.fromIso ?? null,
    p_to: params.toIso ?? null,
  });
  if (error) throw new Error(error.message);
  const rows = (data ?? []) as Array<{
    task_id: string;
    work_order_id: string;
    product_name: string;
    quantity: number;
    unit_price: number;
    line_total: number;
    commission_percent: number | null;
    commission_amount: number;
    work_order_status: string;
    created_at: string;
  }>;
  return rows.map((r) => ({
    taskId: r.task_id,
    workOrderId: r.work_order_id,
    productName: r.product_name,
    quantity: Number(r.quantity),
    unitPrice: Number(r.unit_price),
    lineTotal: Number(r.line_total),
    commissionPercent: r.commission_percent != null ? Number(r.commission_percent) : null,
    commissionAmount: Number(r.commission_amount),
    workOrderStatus: r.work_order_status,
    createdAt: r.created_at,
  }));
}
